
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { Actions, Getters, miscSettingsStore, store } from '@/store';

import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalService from '@/modules/modals/services/modalService';

import WebEnvConfigService from '@/services/TheWebEnvConfigService';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';
import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import MlsImportManager from '@/manager/3.6/MlsImportManager';
import MlsTokenManager from '@/manager/3.6/MlsTokenManager';
import LogUsageManager from '@/manager/LogUsageManager';
import { MlsMapperEventTypes } from '@/constants/MlsMapperEventTypes';
import CompsManager from '@/manager/3.6/CompsManager';
import QSUtils from '@/utils/QSUtils';
import IFeedData from '@/models/comp/IFeedData';

export default defineComponent({
    components: { ModalBody },
    data() {
        return {
            modal: null,
            url: '',
        };
    },
    setup() {
        const store = useStore();
        return {
            store,
        };
    },
    mounted() {
        const modalElement = this.$refs.mlsImport;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, 'auto-mls');
        ModalService.open(this.modal);

        LogUsageManager.importingMlsData();
        this.messageListener();
        this.getMLSPath();
    },
    methods: {
        async getMLSPath() {
            const webEnvConfig = await WebEnvConfigService.getInstance().getConfigByHost();
            const mlsUrl = `${webEnvConfig.urls?.mlsMapperUrl}/${miscSettingsStore.UADVersion}`;
            const mlsToken = await MlsTokenManager.getToken(false);
            const formCode = theLocalStorageUtils.get(LocalStorageKeys.formCode) ? `${theLocalStorageUtils.get(LocalStorageKeys.formCode)}` : '';
            const p2id = theLocalStorageUtils.get(LocalStorageKeys.p2id) ? `${theLocalStorageUtils.get(LocalStorageKeys.p2id)}` : '';
            const usageGuid = theLocalStorageUtils.get(LocalStorageKeys.uuid) ? `${theLocalStorageUtils.get(LocalStorageKeys.uuid)}` : '';
            const source = 'qs';
            const params = `?token=${mlsToken}&formCode=${formCode}&p2id=${p2id}&usageGuid=${usageGuid}&source=${source}`;
            this.url = `${mlsUrl}/import${params}`;
        },
        messageListener() {
            window.addEventListener('message', this.callback, false);
        },
        async callback(event: any) {
            const webEnvConfig = await WebEnvConfigService.getInstance().getConfigByHost();
            const mlsUrl = `${webEnvConfig.urls?.mlsMapperUrl}`;
            if (event.origin === mlsUrl) {
                if (event.data.type === MlsMapperEventTypes.cancel) {
                    ModalService.hide(this.modal);
                    // Need to check if there are any comps.  If not, then relaunch the Jump Start modal
                    if (MlsImportManager.relaunchJumpStartModal()) {
                        (this as any).eventBus.emit('modalJumpStart');
                    }
                } else if (event.data.type === MlsMapperEventTypes.import) {
                    // Not having comps indicates coming from jump start
                    const hasComps = store.getters[Getters.CompAddressesV36.HasComps];

                    // Current logic for handling the import result from the payload
                    //const importResult = MlsImportManager.getImportResultFromPayload(event.data);
                    //const importStats = await MlsImportManager.processAndStore(importResult);
                    //console.log("ImportResult from payload: ", importResult);
                    //console.log("ImportStats from processing importResult: ", importStats);

                    // New logic for handling simple payload and fetching MLS common shape
                    const importResult = MlsImportManager.convertToSimplePayload(event.data.data);
                    const feedDatas = await MlsImportManager.fetchMLSCommonShape(importResult);
                    const importStats = await MlsImportManager.processAndStore2(feedDatas ?? [], event.data.data.mlsInfo, event.data.data);

                    console.log("ImportResult from payload: ", importResult);
                    console.log("FeedDatas from fetching MLS common shape: ", feedDatas);
                    console.log("ImportStats from processing feedDatas: ", importStats);


                    if(QSUtils.debugger()) {
                        console.log("MLS import callback method");
                        console.log("importResult result: ", importResult);
                    }

                    //await QSUtils.sleep(60000);

                    if (importStats.added === 0 && importStats.replaced === 0 && importStats.errors > 0) {
                        // When all properties are in error display a message.
                        ModalService.hide(this.modal);

                        (this as any).eventBus.emit('modalMLSImportAllErrors', {
                            importStats: importStats,
                        });
                    } else {
                        const previouslyVieweds = MlsImportManager.getExistingPreviouslyVieweds();
                        if (previouslyVieweds.length > 0) {
                            ModalService.hide(this.modal);

                            (this as any).eventBus.emit('modalMLSImportPreviouslyViewed', {
                                previouslyVieweds: previouslyVieweds,
                            });
                        } else {
                            await MlsImportManager.processToComps(false);

                            (this as any).eventBus.emit('checkTabOverflow');

                            ModalService.hide(this.modal);
                            QSUtils.removeElementById('JumpStart');

                            if (!hasComps) {
                                // When there are no comps
                                if (importStats.added > 0) {
                                    // On successful imports default active comp to 1
                                    CompsManager.setActiveComp(1);
                                } else if (importStats.added === 0) {
                                    // No comps imported displays a message and possibly redirects back to Jump Start.
                                    (this as any).eventBus.emit('modalMLSImportAllErrors', {
                                        importStats: importStats,
                                    });
                                }
                            }
                        }
                    }
                } else if (event.data.type === MlsMapperEventTypes.loaded) {
                    const iframe = document.getElementById('mlsMapper') as HTMLIFrameElement;
                    MlsImportManager.postMessagesToIFrame(iframe.contentWindow);
                }
            }
        },
    },
});
